/**
 * Dirty detection for project settings that require Save (annotation UI + project-wide viewer chrome).
 *
 * Participants, items, and lifecycle status do not use this bar (participants/items persist
 * immediately; publish uses its own immediate PUT flow).
 */

function normalizeAnnotationUI(ui) {
    const u = ui ?? {};
    return {
        id: u.id ?? '',
        config: u.config ?? {},
    };
}

function normalizeNotesConfig(notes) {
    const n = notes ?? {};
    return {
        enabled: Boolean(n.enabled),
        label: typeof n.label === 'string' ? n.label : null,
        placeholder: typeof n.placeholder === 'string' ? n.placeholder : null,
        instructions: typeof n.instructions === 'string' ? n.instructions : null,
        maxLength: Number.isFinite(n.maxLength) ? n.maxLength : null,
    };
}

/**
 * @param {object} annotationUI - draft annotationUI
 * @param {object} [savedGirderProjects] - girderProjects from last loaded folder doc
 */
export function isProjectSettingsDirty(annotationUI, notesConfig, savedGirderProjects) {
    const gp = savedGirderProjects ?? {};
    const savedAnn = normalizeAnnotationUI(gp.annotationUI);
    const draftAnn = normalizeAnnotationUI(annotationUI);
    const savedNotes = normalizeNotesConfig(gp.notes);
    const draftNotes = normalizeNotesConfig(notesConfig);
    return (
        JSON.stringify(draftAnn) !== JSON.stringify(savedAnn)
        || JSON.stringify(draftNotes) !== JSON.stringify(savedNotes)
    );
}

/** Shown when navigation is blocked due to unsaved annotation UI settings. */
export const DRAFT_NAV_BLOCKED =
    'Save or discard unsaved settings first. This opens the last saved configuration.';
